import { dummyGames, featuredGameIds, newestGameId } from "../../data/dummyGames";

export async function newestGame() {
  return Promise.resolve(dummyGames.find((g) => g.id === newestGameId));
}

export async function featuredGames() {
  return Promise.resolve(
    dummyGames.filter((g) => featuredGameIds.includes(g.id))
  );
}
